export default __webpack_public_path__ + "static/media/virus-1.07a6260c.svg";